<template>
  <div style="height: 100vh;background: #196586">
    <div class="machine-head">
      <div>{{ row.title }}</div>
      <div>{{ row.saiqu_name }}</div>
    </div>

    <div class="machine-box" :style="'height:' + (clientHeight -104) + 'px;'">
      <div class="machine-content">
        <div class="machine-subject">{{row.subject_name}}</div>
        <div class="machine-army">{{row.mingcheng}}</div>
      </div>
    </div>
  </div>
</template>
<style>
body {
  overflow-y: hidden;
}

.machine-table {
  width: 100%;
  color: #E3E59D;
}

.machine-box {
  background: #0782B8;
  text-align: center;
  color: #E3E59D;
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  align-items: center; /*使子项目垂直居中*/
}

.machine-content {
  margin: -160px 80px 0;
}

.machine-content .machine-subject {
  font-size: 36px;
}

.machine-content .machine-army {
  font-size: 42px;
  margin-top: 40px;
  font-weight: 500;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table th, table td {
  height: 50px;
  font-size: 16px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}

table td a {
  color: #E3E59D;
}

table td a:hover {
  color: #F2EB92;
  text-decoration: underline;
}

table td a.disabled {
  color: #999;
}
table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  color: white;
  background-color: #0782B8;
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:nth-child(2) {
  width: 400px;
}

table tbody td:nth-child(2) {
  width: 400px;
}

table thead th:nth-child(3) {
  width: 360px;
}

table tbody td:nth-child(3) {
  width: 360px;
}

table thead th:nth-child(4) {
  width: 100px;
}

table tbody td:nth-child(4) {
  width: 100px;
}
/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tr:nth-child(even) {
  background: #0782B8;
}

.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 0;
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: 500;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


</style>
<script>
import qs from 'qs'
import {
  getStartMachineDetail,
  createRankBook
} from '@/api/dscore'
import EditableCell from '@/components/EditableCell/'
import moment from 'moment'
import setting from "../../config/setting";

export default {
  name: 'ScoreStartMachineList',
  components: {
    EditableCell
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperColNew: {
        xs: {span: 24},
        sm: {span: 12},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      form: this.$form.createForm(this),
      row: {
      },
      scoreList: [],
      formData: {
        id: 0
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'

    // 获取数据
    that.fetch()

    // 换成轮询
    // that.timer = setInterval(function () {
    //   that.fetch()
    // }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {
    moment,
    fetch() {
      //刷新数据
      const that = this

      getStartMachineDetail({
        subject_id: that.$route.query.subject_id || 0,
      }).then(res => {
        that.row = res.data
        // that.scoreList = res.data.list
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },

    createRankBook() {
      let that = this;
      let query = {}
      query.sjsq = that.queryParam.sjsq
      query.subjects = [that.queryParam.subjectRow]
      createRankBook(query).then(res => {
        that.$message.success('生成成功')
      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    download(type) {
      let that = this;
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/dscore/rankListDownload?' + qs.stringify(that.queryParam));
          break;
      }
    },

    handleOpenArmy(record) {
      window.open('ScoreStartMachineArmy?subject_id='+record.id)
    },

    handleOpenRank(record) {
      window.open('ScoreStartMachineRank?subject_id='+record.id)
    },

    handleOpenSubjectRank(record) {
      window.open('ScoreStartMachineSubjectRank?subject_id='+record.id)
    },
  }
}
</script>
